import { ProductOptions } from './types';

export function isSingleProductOption(options: ProductOptions) {
    const entries = Object.entries(options);

    return entries.length === 1 && typeof entries[0][1] === 'string';
}

export function getDefaultProductValue(options: ProductOptions) {
    if (isSingleProductOption(options)) {
        const [value] = getSingleProductOption(options);

        return value;
    }

    return '';
}

export function getSingleProductOption(options: ProductOptions) {
    if (!isSingleProductOption(options)) {
        throw new Error('There are multiple product options');
    }

    const [entry] = Object.entries(options);

    return [entry[0], entry[1]] as const;
}
